import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { interval, Subscription } from 'rxjs';


@Component({
  selector: 'app-login-verification',
  templateUrl: './login-verification.component.html',
  styleUrls: ['./login-verification.component.css']
})
export class LoginVerificationComponent implements OnInit {
  public validationForm: FormGroup;
  public userData: any;

  isResendDisabled: boolean = false; // Bandera para habilitar/deshabilitar la función
  timeRemaining: number = 0; // Tiempo restante en segundos
  formattedTime: string = ''; // Tiempo formateado para mostrar

  private countdownSubscription!: Subscription;

  codigoInputs = Array(6).fill(null); // Crea un arreglo para los 6 inputs


  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LoginVerificationComponent>,
    private _usuarioService: UsuarioService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // this.validationForm = this.fb.group({
    //   codigo: ['', [Validators.required, Validators.minLength(6)]]
    // });

    this.userData = data;
  }

  ngOnInit(): void {
    this.validationForm = this.fb.group(
      this.codigoInputs.reduce((controls, _, index) => {
        controls['codigo' + index] = ['', [Validators.required, Validators.maxLength(1)]];
        return controls;
      }, {})
    );
  }


  get codigoControl() {
    return this.validationForm.get('codigo');
  }

  public getFormattedEmail(email: string): string {
    if (!email || !email.includes('@')) {
      return email; // Devuelve el email sin formato si es inválido
    }
    
    const [localPart, domain] = email.split('@');
    const obfuscatedLocal = localPart.slice(0, 2) + '*'.repeat(Math.max(localPart.length - 2, 1));
    const obfuscatedDomain = domain[0] + '*'.repeat(Math.max(domain.indexOf('.'), 1)) + domain.slice(domain.indexOf('.'));
    
    return `${obfuscatedLocal}@${obfuscatedDomain}`;
  }

  private intentosFallidos: number = 0;
  private maxIntentos: number = 5;
  reenviarCodigo() {
    if (this.isResendDisabled) {
      return; // Evita llamar la función si está deshabilitada
    }

     // Bloquea la función y establece el temporizador
     this.isResendDisabled = true;
     this.timeRemaining = 60; // 1 minuto en segundos
     this.formattedTime = this.formatTime(this.timeRemaining);
 
     // Inicia la cuenta regresiva
     this.countdownSubscription = interval(1000).subscribe(() => {
       if (this.timeRemaining > 0) {
         this.timeRemaining--;
         this.formattedTime = this.formatTime(this.timeRemaining);
       } else {
         this.isResendDisabled = false; // Habilita la función después del tiempo
         this.countdownSubscription.unsubscribe(); // Detiene el temporizador
       }
     });
    // Llamar al servicio para reenviar el código
    this._usuarioService.postReenviarCodigo(this.userData)
      .then((data: any) => {
        // console.log(data);
        

        if (data.status == false) {
          Swal.fire({
            allowOutsideClick: false,
            html: `
              <div style="text-align: center; padding: 10px; max-width: 100%; word-wrap: break-word;">
                <i class="material-icons" style="color:#171994; font-size: 48px; margin: 10px auto; display: block;">error_outline</i>
                <h1 style="
                    font-family: Mulish, sans-serif; 
                    font-style: normal; 
                    font-weight: 600; 
                    font-size: 20px; 
                    line-height: 1.4; 
                    margin-bottom: 8px; 
                    word-wrap: break-word;">
                  ${data.title}
                </h1>
                <h1 style="
                    font-family: Mulish, sans-serif; 
                    font-style: normal; 
                    font-weight: 600; 
                    font-size: 18px; 
                    line-height: 1.2; 
                    word-wrap: break-word; 
                    color: #555;">
                  ${data.subtitle}
                </h1>
              </div>`,
            showConfirmButton: true,
          }).then(() => {
            this.cerrarModal(); // Cerrar el modal
            this.dialogRef.close({ status: false, reason: 'max_attempts' }); // Notificar el cierre
          });
          return;
        } else{
          Swal.fire({
            allowOutsideClick: false,
            html: `
              <div style="text-align: center; padding: 10px; max-width: 100%; word-wrap: break-word;">
                <i class="material-icons" style="color:#171994; font-size: 48px; margin: 10px auto; display: block;">error_outline</i>
                <h1 style="
                    font-family: Mulish, sans-serif; 
                    font-style: normal; 
                    font-weight: 600; 
                    font-size: 20px; 
                    line-height: 1.4; 
                    margin-bottom: 8px; 
                    word-wrap: break-word;">
                  ${data.title}
                </h1>
                <h1 style="
                    font-family: Mulish, sans-serif; 
                    font-style: normal; 
                    font-weight: 600; 
                    font-size: 18px; 
                    line-height: 1.2; 
                    word-wrap: break-word; 
                    color: #555;">
                  ${data.subtitle}
                </h1>
              </div>`,
            showConfirmButton: true,
          });
        }
      })
      .catch((error: any) => {
        console.error('Error al reenviar el código:', error);
  
        Swal.fire({
          allowOutsideClick: false,
          html: `
            <div style="text-align: center; padding: 10px; max-width: 100%; word-wrap: break-word;">
              <i class="material-icons" style="color:#171994; font-size: 48px; margin: 10px auto; display: block;">error_outline</i>
              <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 20px; 
                  line-height: 1.4; 
                  margin-bottom: 8px; 
                  word-wrap: break-word;">
                Error al reenviar el código
              </h1>
              <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 18px; 
                  line-height: 1.2; 
                  word-wrap: break-word; 
                  color: #555;">
                Hubo un problema al intentar reenviar el código. Por favor, intenta nuevamente.
              </h1>
            </div>`,
          showConfirmButton: true,
        });
      });
  }
  

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  

  

  verificarCodigo() {
    // Validar si el formulario es inválido (si algún campo está vacío o incorrecto)
    if (this.validationForm.invalid) {
      alert('Por favor, ingresa un código válido de 6 dígitos.');
      return;
    }
  
    // Obtener los valores de los 6 campos de entrada y concatenarlos para formar el código
    const codigo = Object.values(this.validationForm.value).join('');
    // console.log('Código ingresado:', codigo);
  
    // Verificar que el código tenga exactamente 6 caracteres
    if (codigo.length !== 6) {
      alert('Por favor, ingresa un código completo de 6 dígitos.');
      return;
    }
    // console.log('Intentos fallidos:', this.intentosFallidos);
  
    // console.log('El código ingresado es:', codigo);
  
    // Verificar que los datos del usuario estén presentes
    if (!this.userData || !this.userData.use_id || !this.userData.use_rut) {
      console.error('Datos del usuario incompletos: use_id o use_rut no están disponibles.');
      alert('Hubo un problema con los datos del usuario. Inténtalo nuevamente más tarde.');
      return;
    }
  
    // Llamar al servicio para validar el código
    this._usuarioService.valida2FA({
      codigo,
      use_id: this.userData.use_id,
      use_rut: this.userData.use_rut,
      use_typ_id: this.userData.use_typ_id,
      requiresOnboarding: this.userData.use_onboarding,
      requiresOnboardingInfo: this.userData.use_datos_completed,
      requiresOnboardingPass: this.userData.use_password_default
    })
      .then((data: any) => {
        // console.log('Respuesta del servicio:', data);
  
        if (data.status === true) {
          // console.log('Código verificado con éxito', data);
          this.intentosFallidos = 0; // Reinicia el contador de intentos fallidos
          this.cerrarModal(); // Cierra el modal
          this.dialogRef.close(data); // Devuelve la respuesta al componente que abrió el modal
        } else {
          // console.log('Código incorrecto:', data.title);
          this.intentosFallidos++; // Incrementa el contador de intentos fallidos
          // console.log('Intentos fallidos:', this.intentosFallidos);
          
          // Verifica si el usuario ha alcanzado el máximo de intentos permitidos
          if (this.intentosFallidos >= this.maxIntentos) {
            this.validationForm.reset();
            Swal.fire({
              allowOutsideClick: false,
              html: `
                <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">info_outline</i> <br><br>
                <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 20px; 
                  line-height: 1.4; 
                  margin-bottom: 8px; 
                  word-wrap: break-word;">
                Haz alcanzado el maximo de intentos permitidos</h1>
                <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 18px; 
                  line-height: 1.2; 
                  word-wrap: break-word; 
                  color: #555;">Por favor, vuelve a solicitar un nuevo código </h1> 
                <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
              showConfirmButton: true,
            }).then(() => {
              this._usuarioService.postInvalidarCodigo({use_id: this.userData.use_id});
              // console.log('se ejecutó funcion postInvalidarCodigo');
              this.intentosFallidos = 0;
            });
            return;
          }
          this.validationForm.reset();

          Swal.fire({
            allowOutsideClick: false,
            html: `
              <div style="text-align: center; padding: 10px; max-width: 100%; word-wrap: break-word;">
                <i class="material-icons" style="color:#171994; font-size: 48px; margin: 10px auto; display: block;">mood_bad</i>
                <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 20px; 
                  line-height: 1.4; 
                  margin-bottom: 8px; 
                  word-wrap: break-word;">
                  ${data.title}
                </h1>
                <h1 style="
                  font-family: Mulish, sans-serif; 
                  font-style: normal; 
                  font-weight: 600; 
                  font-size: 18px; 
                  line-height: 1.2; 
                  word-wrap: break-word; 
                  color: #555;">
                  ${data.subtitle}
                </h1>
              </div>`,
            showConfirmButton: true,
          });
          
        }
      })
      .catch((error) => {
        console.error('Error al verificar el código:', error);
        Swal.fire({
          allowOutsideClick: false,
          html: `
            <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
            <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;"></h1> <br>
            <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
          showConfirmButton: true,
        });
      });
  }
  

  onInput(event: Event, index: number): void {
    const inputElement = event.target as HTMLInputElement; // Convertir a HTMLInputElement
    const value = inputElement.value.toUpperCase(); // Convertir el carácter ingresado a mayúsculas
    inputElement.value = value;
  
    const nextInput = document.querySelectorAll('.code-input')[index + 1] as HTMLInputElement;
  
    // Mover el foco al siguiente input si existe y el valor tiene 1 carácter
    if (value.length === 1 && nextInput) {
      nextInput.focus();
    }
  }
  
  onKeyDown(event: KeyboardEvent, index: number): void {
    const inputElement = event.target as HTMLInputElement; // Convertir a HTMLInputElement
    const previousInput = document.querySelectorAll('.code-input')[index - 1] as HTMLInputElement;
  
    // Si la tecla presionada es Backspace y el campo está vacío, mover el foco al anterior
    if (event.key === 'Backspace' && !inputElement.value && previousInput) {
      previousInput.focus();
    }
  }
  
  onPaste(event: ClipboardEvent): void {
    const pastedText = (event.clipboardData?.getData('text') || '').trim(); // Obtén el texto pegado
    
    if (pastedText.length === this.codigoInputs.length) {
      // Encuentra todos los campos de entrada
      const inputs = document.querySelectorAll<HTMLInputElement>('.code-input');
      
      // Distribuye cada carácter en los campos
      pastedText.split('').forEach((char, index) => {
        if (inputs[index]) {
          inputs[index].value = char; // Asigna el valor al campo
          this.validationForm.get(`codigo${index}`)?.setValue(char); // Actualiza el FormGroup
        }
      });
      
      event.preventDefault(); // Previene el comportamiento predeterminado de pegado
    } else {
      Swal.fire({
        allowOutsideClick: false,
        html: `
          <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
          <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">El formato del código que deseas utilizar no es valido.</h1>
          <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
        showConfirmButton: true,
      });    }
  }
  
  
  

  cerrarModal() {
    this.dialogRef.close(null); // Cierra el modal sin devolver resultado
  }
}
